module.exports = __webpack_public_path__ + "static/img/10.64f6701.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/zh/10.png
// module id = 3KcK
// module chunks = 0